export default "__VITE_ASSET__611a6d35__"